import { Language } from '../interfaces/Localization';

export const allowedLanguages: Language[] = [
  { locale: 'tr', name: 'Türkçe' },
  { locale: 'en', name: 'English' },
  { locale: 'ru', name: 'Русский' },
  { locale: 'de', name: 'Deutsch' },
  { locale: 'ar', name: 'العربية' },
  { locale: 'fr', name: 'Français' },
  { locale: 'es', name: 'Español' },
  { locale: 'it', name: 'Italiano' },
  { locale: 'pt', name: 'Português' },
  { locale: 'nl', name: 'Nederlands' },
];
